export const setCookie = (name, value, exdays) => {
  const d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  const expires = `expires=` + d.toUTCString();
  document.cookie = name + `=` + value + `;` + expires + `;path=/;domain=` + window.location.hostname.split(`.`).slice(-2).join(`.`);
};
